onInteractive(function () {
	// Reveal-on-scroll: blocks fade and rise into place the first time they enter
	// the viewport. The hidden start state is only applied once JS and the observer
	// are confirmed, so a no-JS or reduced-motion visit shows everything up front.
	var reducedMotion = window.matchMedia
		&& window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	if (!('IntersectionObserver' in window) || reducedMotion) {
		return;
	}

	var selectors = [
		'.hero-main',
		'.hero-aside',
		'.masterbrew-text',
		'.feature-grid .feature',
		'.overons-media',
		'.overons-text',
		'.assortiment-text',
		'.assortiment-media',
		'.proeverij-text',
		'.counters .counter-item',
		'.content-intro .container',
		'.content-media-text',
		'.content-media-image',
		'.content-block-text .container',
		'.content-block-centered .container',
		'.content-block-photo',
		'.bieren-grid .bier-col',
		'.rondl-cards .rondl-card',
		'.contact-info',
		'.contact-form'
	];

	var targets = Array.prototype.slice.call(
		document.querySelectorAll(selectors.join(','))
	);
	if (!targets.length) {
		return;
	}

	document.documentElement.classList.add('js-reveal');
	targets.forEach(function (el) {
		el.classList.add('reveal');
	});

	var observer = new IntersectionObserver(function (entries) {
		entries.forEach(function (entry) {
			if (!entry.isIntersecting) {
				return;
			}
			var el = entry.target;

			// Stagger reveal siblings so grids and rows cascade in one after another
			// instead of snapping in as a single block.
			var group = Array.prototype.slice.call(
				el.parentNode ? el.parentNode.children : []
			).filter(function (node) {
				return node.classList && node.classList.contains('reveal');
			});
			var index = Math.max(0, group.indexOf(el));
			// el.style.transitionDelay = (index * 90) + 'ms';

			el.classList.add('is-visible');
			observer.unobserve(el);
		});
	}, {
		rootMargin: '0px 0px -8% 0px',
		threshold: 0.12
	});

	targets.forEach(function (el) {
		observer.observe(el);
	});
});

onComplete(function () {
	// Give the fixed/transparent home header a solid background once the visitor
	// scrolls past the hero, so the navigation stays readable over the content.
	var header = document.querySelector('.nav-header');
	if (header) {
		var onScroll = function () {
			header.classList.toggle('scrolled', window.scrollY > 200);
		};
		onScroll();
		window.addEventListener('scroll', onScroll, { passive: true });
	}

	// Fullscreen slide-up mobile menu.
	var toggle = document.querySelector('[data-nav-toggle]');
	var root = document.documentElement;
	var closeMenu = function () {
		root.classList.remove('nav-open');
		if (toggle) {
			toggle.setAttribute('aria-expanded', 'false');
			toggle.setAttribute('aria-label', toggle.getAttribute('data-label-open') || '');
		}
	};
	if (toggle) {
		toggle.addEventListener('click', function () {
			var open = root.classList.toggle('nav-open');
			toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
			toggle.setAttribute(
				'aria-label',
				(open ? toggle.getAttribute('data-label-close') : toggle.getAttribute('data-label-open')) || ''
			);
		});

		document.querySelectorAll('.nav-overlay a').forEach(function (link) {
			link.addEventListener('click', closeMenu);
		});
		document.addEventListener('keydown', function (event) {
			if (event.key === 'Escape') {
				closeMenu();
			}
		});
	}

	// Count the statistics up from zero the first time they scroll into view.
	var counters = document.querySelectorAll('.counters .counter');
	if (counters.length && 'IntersectionObserver' in window) {
		var animate = function (el) {
			var target = parseInt((el.textContent || '').replace(/\D/g, ''), 10) || 0;
			var start = null;
			var duration = 1800;
			var step = function (timestamp) {
				if (start === null) {
					start = timestamp;
				}
				var progress = Math.min((timestamp - start) / duration, 1);
				el.textContent = Math.floor(progress * target);
				if (progress < 1) {
					window.requestAnimationFrame(step);
				}
			};
			window.requestAnimationFrame(step);
		};
		var observer = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					animate(entry.target);
					observer.unobserve(entry.target);
				}
			});
		}, { threshold: 0.5 });
		counters.forEach(function (counter) {
			observer.observe(counter);
		});
	}
});
